import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_90, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  shapesBox: {
    padding: theme.spacing(4),
    backgroundColor: '#D7486E',
    borderRadius: 10,
    color: theme.palette.common.black,
  },
  borderRightMd: {
    paddingBottom: theme.spacing(3.5),
    marginBottom: theme.spacing(3.5),
    borderBottom: `1.5px solid #DDDDDD`,
    margin: theme.spacing(0, 2),
  },
  sizeWrapper: {
    padding: theme.spacing(0, 4),
    alignItems: 'flex-end',
  },
  shapesBoxItem: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2.5),
    textAlign: 'center',
    maxWidth: '155px',
    borderRadius: 8,
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FFE8F2',
    },
    '&:hover $shapeButton': {
      borderColor: COLOR_PINK,
      borderWidth: `1.5px`,
      backgroundColor: 'transparent',
    },
    '&:hover $shapeTitle': {
      textDecoration: 'underline',
    },
    '&:hover $shapeButtonImage': {
      content: 'url("/images/plus-circle-filled.svg")',
    },
    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
  shapeButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '140px',
  },
  shapeButton: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderWidth: `1.5px`,
    borderColor: '#424242',
    borderRadius: 4,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  shapeButtonDisabled: {
    borderColor: `${theme.palette.grey[400]} !important`,
  },
  abstract: {
    width: 89,
    height: 57,
  },
  slide: {
    width: 110,
    height: 88,
  },
  infographic: {
    width: 85,
    height: 119,
  },
  poster: {
    width: 110,
    height: 132,
  },
  shapeButtonProgress: {
    color: COLOR_PINK,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: theme.spacing(2.5),
    margin: theme.spacing(-2, 2, 2),
    fontFamily: 'lato',
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '20px',
    color: COLOR_GRAY_90,
    borderBottom: `1.5px solid #DDDDDD`,
    '& .headerLink': {
      color: COLOR_PINK,
      fontSize: 16,
      lineHeight: '24px',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  shapeTitle: {
    fontFamily: 'lato',
    fontSize: 16,
    lineHeight: '24px',
    color: COLOR_GRAY_90,
    minHeight: '48px',
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  customHeader: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0, 2, 1),
    justifyContent: 'space-between',
  },
  customTitle: {
    fontFamily: 'lato',
    fontWeight: 700,
    fontSize: 24,
    lineHeight: '20px',
    color: COLOR_GRAY_90,
  },
  arrow: {
    width: '12px',
    height: '12px',
    borderLeft: '2px solid black',
    borderBottom: '2px solid black',
    transform: 'rotate(-45deg)',
    marginLeft: '8px',
    transition: 'transform 0.3s ease',
    cursor: 'pointer',
    marginRight: theme.spacing(0.5),
    borderBottomLeftRadius: '2px',
  },
  arrowUp: {
    transform: 'rotate(135deg)',
  },
  shapeButtonImage: {
    width: '35px',
    height: '35px',
    objectFit: 'contain',
    transition: '0.3s ease',
    display: 'block',
    visibility: 'visible',
    opacity: 1,
    content: 'url("/images/plus-circle.svg")',
  },
  actionsOverride: {
    padding: '0px !important',
  },
}));
